import './styles.scss';
const SubHeading = ({ text = '' }) => (
  <span className="sub-heading">{text}</span>
);

export default SubHeading;
